// Desktop Menu Handler
let lastScrollY = window.scrollY;
const header = document.querySelector('.header');

window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling down
        header.classList.add('hide-header');
    } else {
        // Scrolling up
        header.classList.remove('hide-header');
    }
    
    if (currentScrollY > 0) {
        header.classList.add('scrolled');
    } else {
        header.classList.remove('scrolled');
    }
});

const mobileMenu = document.querySelector('.mobile-menu-container');
const mobileMenuToggle = document.querySelector('.hamburger-menu');

mobileMenuToggle.addEventListener('click', () => {
    if (mobileMenu.classList.contains('open')) {
        mobileMenu.classList.add('closing');
        mobileMenuToggle.classList.remove('active');
        mobileMenu.addEventListener('animationend', () => {
            mobileMenu.classList.remove('open');
            mobileMenu.classList.remove('closing');
            mobileMenu.style.display = 'none';
        }, { once: true });
    } else {
        mobileMenu.style.display = 'block';
        mobileMenuToggle.classList.add('active');
        void mobileMenu.offsetWidth;
        mobileMenu.classList.add('open');
    }
});

// Submenu Reposition on small screens
document.querySelectorAll('.menu-item').forEach(item => {
    item.addEventListener('mouseenter', () => {
      const submenu = item.querySelector('.submenu');
      if (!submenu) return;
  
      // Reset position first
      submenu.style.left = '';
      submenu.style.right = '';
  
      const rect = submenu.getBoundingClientRect();
  
      if (rect.right > window.innerWidth) {
        // Overflowing right side — flip it
        submenu.style.left = 'auto';
        submenu.style.right = '0';
      } else {
        // Normal placement
        submenu.style.left = '0';
        submenu.style.right = 'auto';
      }
    });
});

